export * from './DualThumb';

export * from './SingleThumb';
